import { render, staticRenderFns } from "./filterFav.vue?vue&type=template&id=24277cc0"
import script from "./filterFav.vue?vue&type=script&lang=js"
export * from "./filterFav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports